import React, { useState } from 'react';
import './style.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import { AnimatedHeading } from '../../shared/TextFx';
import heroVideo from './../../assets/Banner-vid1.mp4';

const HERO_TITLE = 'Time critical logistics. When it cannot wait, we move.';
const HERO_DESC =
  'Critical shipments do not need more. They need decisions, coordination and control.';

const SLIDES = [
  { dataService: 1, words: ['On', 'Board', 'Courier', '(OBC)'] },
  { dataService: 2, words: ['Hybrid', 'On', 'Board', 'Courier'] },
  { dataService: 4, words: ['Next', 'Flight', 'Out', '(NFO)'] },
  { dataService: 6, words: ['Next', 'Flight', 'Out', 'Express'] },
  { dataService: 3, words: ['Air', 'Charters'] },
  { dataService: 5, words: ['Customs', 'Brokerage'] },
];

/**
 * Replays the GSAP char-reveal on the newly active slide's title, mirroring
 * the source's `replayTitle()`. Dynamically imported so this component
 * still works (just without the reveal flourish) if gsap isn't installed.
 */
async function replaySlideTitle(swiper) {
  try {
    const activeSlideEl = swiper.slides[swiper.activeIndex];
    if (!activeSlideEl) return;
    const chars = activeSlideEl.querySelectorAll('.animated-text .char');
    if (!chars.length) return;
    const { gsap } = await import('gsap');
    gsap.fromTo(
      chars,
      { scaleY: 0 },
      { scaleY: 1, duration: 0.5, stagger: 0.015, ease: 'power2.out', transformOrigin: '50% 0%' }
    );
  } catch (err) {
    // gsap not installed or animation failed — slide still works, just without the reveal
  }
}

const BannerSec = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSwiper = (swiper) => replaySlideTitle(swiper);
  const handleSlideChangeTransitionStart = (swiper) => {
    setActiveIndex(swiper.realIndex);
    replaySlideTitle(swiper);
  };

  return (
    <div className="hero__video-container">
      <div className="hero__video-wrapper">
        {/* <div className="hero__video-cover">
          <video className="hero__video" autoPlay loop muted playsInline preload="auto" src={heroVideo} />
        </div> */}
      </div>

      <section className="hero" id="hero">
        <div className="hero__container container">
          <div className="hero__head main-animated-text">
            <div className="hero__abb">
              <div className="hero__abb-wrapper">
                <span className="hero__abb-item">E.</span>
                <span className="hero__abb-item">X.</span>
                <span className="hero__abb-item">P.</span>
              </div>
              <span className="hero__abb-text">Esquire Express LOGISTICS</span>
            </div>
            <span className="hero__head-line main-animated-line" />
          </div>

          <div className="hero__container-inner">
            <div className="hero__content">
              <AnimatedHeading as="h1" className="hero__title main-animated-text" text={HERO_TITLE} />
              <AnimatedHeading as="p" className="hero__desc main-animated-text" text={HERO_DESC} />
            </div>

            {/* <a className="hero__btn btn" href="#services">
              SPECIALISED SOLUTIONS
            </a> */}

            {/* <div className="hero-slider">
              <div className="hero-slider__head">
                <div className="hero-slider__counter">
                  <span className="hero-slider__counter-current">{String(activeIndex + 1).padStart(2, '0')}</span>
                  <span className="hero-slider__counter-total">/{String(SLIDES.length).padStart(2, '0')}</span>
                </div>
                <h3 className="hero-slider__title">SPECIALISED SOLUTIONS</h3>
              </div>

              <Swiper
                modules={[EffectFade, Autoplay, Pagination]}
                effect="fade"
                fadeEffect={{ crossFade: true }}
                loop
                speed={700}
                autoplay={{ delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                pagination={{ el: '.hero-slider__progressbar', type: 'progressbar' }}
                onSwiper={handleSwiper}
                onSlideChangeTransitionStart={handleSlideChangeTransitionStart}
              >
               
                <div className="hero-slider__progressbar swiper-pagination swiper-pagination-progressbar swiper-pagination-horizontal" slot="container-start" />

                {SLIDES.map((slide) => (
                  <SwiperSlide className="hero-slider__item" key={slide.dataService}>
                    <a className="hero-slider__item-inner" data-service={slide.dataService} href="#services">
                      <AnimatedHeading as="div" className="hero-slider__item-title" text={slide.words} />
                      <span className="hero-slider__item-box" />
                    </a>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BannerSec;